export default [
  {
    'key': 'fileInformation',
    'name': 'File Information',
    'tags': [
      'FileName',
      'Directory',
      'FileSize',
      'FileType',
      'FileTypeExtension',
      'MIMEType',
      'FileModifyDate',
      'FileAccessDate',
      'FileInodeChangeDate',
      'ExifByteOrder',
      'CurrentIPTCDigest',
      'XMPToolkit',
      'JFIFVersion',
      'ExifVersion',
      'FlashpixVersion',
      'InteropIndex',
      'InteropVersion',
      'SubfileType',
      'NewSubfileType',
      'ImageWidth',
      'ImageHeight',
      'ImageSize',
      'BitsPerSample',
      'Compression',
      'PhotometricInterpretation',
      'Orientation',
      'SamplesPerPixel',
      'PlanarConfiguration',
      'RowsPerStrip',
      'StripOffsets',
      'StripByteCounts',
      'TileWidth',
      'TileLength',
      'TileOffsets',
      'TileByteCounts',
      'YCbCrSubSampling',
      'YCbCrPositioning',
      'ResolutionUnit',
      'XResolution',
      'YResolution',
      'ThumbnailImage',
      'ThumbnailOffset',
      'ThumbnailLength',
    ],
  },
  {
    'key': 'camera',
    'name': 'Camera',
    'tags': [
      'Make',
      'Model',
      'CameraModelName',
      'UniqueCameraModel',
      'CameraSerialNumber',
      'SerialNumber',
      'BodySerialNumber',
      'InternalSerialNumber',
      'FirmwareVersion',
      'Software',
      'ProcessingSoftware',
      'OwnerName',
      'CameraOwnerName',
      'HostComputer',
      'ImageUniqueID',
      'DeviceSettingDescription',
    ],
  },
  {
    'key': 'exposure',
    'name': 'Exposure',
    'tags': [
      'ExposureTime',
      'ShutterSpeed',
      'ShutterSpeedValue',
      'FNumber',
      'Aperture',
      'ApertureValue',
      'MaxApertureValue',
      'ExposureProgram',
      'ExposureMode',
      'ExposureCompensation',
      'ExposureBiasValue',
      'ExposureIndex',
      'RecommendedExposureIndex',
      'ExposureValue',
      'ISO',
      'PhotographicSensitivity',
      'SensitivityType',
      'StandardOutputSensitivity',
      'RecommendedExposureIndex',
      'ISOSpeed',
      'ISOSpeedLatitudeyyy',
      'ISOSpeedLatitudezzz',
      'MeteringMode',
      'LightSource',
      'Flash',
      'FlashEnergy',
      'FlashFired',
      'FlashFunction',
      'RedEyeReduction',
      'FocalLength',
      'FocalLengthIn35mmFormat',
      'DigitalZoomRatio',
      'SubjectDistance',
      'SubjectDistanceRange',
      'SubjectArea',
      'BrightnessValue',
      'WhiteBalance',
      'SceneCaptureType',
      'SceneType',
      'SensingMethod',
      'CustomRendered',
      'GainControl',
      'Contrast',
      'Saturation',
      'Sharpness',
    ],
  },
  {
    'key': 'lens',
    'name': 'Lens',
    'tags': [
      'LensMake',
      'LensModel',
      'LensSerialNumber',
      'LensInfo',
      'LensSpecification',
      'Lens',
      'FocalLength',
      'FocalLengthIn35mmFormat',
      'MaxApertureValue',
    ],
  },
  {
    'key': 'captureInfo',
    'name': 'Capture Info',
    'tags': [
      'DateTimeOriginal',
      'CreateDate',
      'ModifyDate',
      'DateTimeDigitized',
      'SubSecTime',
      'SubSecTimeOriginal',
      'SubSecTimeDigitized',
      'OffsetTime',
      'OffsetTimeOriginal',
      'OffsetTimeDigitized',
      'TimeZoneOffset',
      'ImageDescription',
      'UserComment',
      'MakerNoteSafety',
      'ComponentsConfiguration',
      'CompressedBitsPerPixel',
      'PixelXDimension',
      'PixelYDimension',
      'FileSource',
      'RelatedSoundFile',
      'SpectralSensitivity',
      'OECF',
      'SpatialFrequencyResponse',
      'Noise',
      'FocalPlaneXResolution',
      'FocalPlaneYResolution',
      'FocalPlaneResolutionUnit',
      'SubjectLocation',
      'ExposureIndex',
      'Saturation',
      'Sharpness',
      'Contrast',
      'DeviceSettingDescription',
    ],
  },
  {
    'key': 'geoLocation',
    'name': 'Geo Location',
    'tags': [
      'GPSVersionID',
      'GPSLatitudeRef',
      'GPSLatitude',
      'GPSLongitudeRef',
      'GPSLongitude',
      'GPSAltitudeRef',
      'GPSAltitude',
      'GPSPosition',
      'GPSTimeStamp',
      'GPSDateStamp',
      'GPSDateTime',
      'GPSMapDatum',
      'GPSMeasureMode',
      'GPSStatus',
      'GPSSatellites',
      'GPSDOP',
      'GPSSpeedRef',
      'GPSSpeed',
      'GPSTrackRef',
      'GPSTrack',
      'GPSImgDirectionRef',
      'GPSImgDirection',
      'GPSDestLatitudeRef',
      'GPSDestLatitude',
      'GPSDestLongitudeRef',
      'GPSDestLongitude',
      'GPSDestBearingRef',
      'GPSDestBearing',
      'GPSDestDistanceRef',
      'GPSDestDistance',
      'GPSProcessingMethod',
      'GPSAreaInformation',
      'GPSDifferential',
      'GPSHPositioningError',
    ],
  },
  {
    'key': 'colorIccProfile',
    'name': 'Color / ICC Profile',
    'tags': [
      'ColorSpace',
      'ProfileDescription',
      'ICCProfileName',
      'ProfileCMMType',
      'ProfileVersion',
      'ProfileClass',
      'ProfileConnectionSpace',
      'ProfileDateTime',
      'PrimaryPlatform',
      'CMMFlags',
      'DeviceManufacturer',
      'DeviceModel',
      'DeviceAttributes',
      'DeviceSerialNumber',
      'RenderingIntent',
      'MediaWhitePoint',
      'MediaBlackPoint',
      'ChromaticAdaptation',
      'Luminance',
      'Measurement',
      'Technology',
      'ViewingCondDesc',
      'ViewingCondIlluminant',
      'ViewingCondSurround',
      'RedMatrixColumn',
      'GreenMatrixColumn',
      'BlueMatrixColumn',
      'RedTRC',
      'GreenTRC',
      'BlueTRC',
      'Gamma',
      'WhitePoint',
      'PrimaryChromaticities',
    ],
  },
  {
    'key': 'creatorCopyrightIptc',
    'name': 'Creator / Copyright / IPTC',
    'tags': [
      'Artist',
      'Creator',
      'CreatorWorkEmail',
      'CreatorWorkTelephone',
      'CreatorWorkURL',
      'CreatorCity',
      'CreatorRegion',
      'CreatorPostalCode',
      'CreatorCountry',
      'Credit',
      'Source',
      'Copyright',
      'CopyrightNotice',
      'RightsUsageTerms',
      'CopyrightURL',
      'WebStatement',
      'OwnerName',
      'Title',
      'ObjectName',
      'Headline',
      'Caption-Abstract',
      'Description',
      'Keywords',
      'Subject',
      'Category',
      'SupplementalCategories',
      'By-line',
      'By-lineTitle',
      'Writer-Editor',
      'Instructions',
      'JobID',
      'TransmissionReference',
      'Urgency',
      'DateCreated',
      'TimeCreated',
      'DigitalCreationDate',
      'DigitalCreationTime',
      'City',
      'Sub-location',
      'Province-State',
      'Country-PrimaryLocationName',
      'Country-PrimaryLocationCode',
    ],
  },
  {
    'key': 'xmp',
    'name': 'XMP',
    'tags': [
      'XMPToolkit',
      'XMP:CreateDate',
      'XMP:ModifyDate',
      'XMP:MetadataDate',
      'XMP:CreatorTool',
      'XMP:Label',
      'XMP:Rating',
      'XMP-xmp:CreateDate',
      'XMP-xmp:ModifyDate',
      'XMP-xmp:MetadataDate',
      'XMP-dc:Title',
      'XMP-dc:Description',
      'XMP-dc:Creator',
      'XMP-dc:Rights',
      'XMP-dc:Subject',
      'XMP-dc:Publisher',
      'XMP-dc:Identifier',
      'XMP-dc:Source',
      'XMP-dc:Type',
      'XMP-dc:Format',
      'XMP-xmpRights:Marked',
      'XMP-xmpRights:UsageTerms',
      'XMP-xmpRights:WebStatement',
      'XMP-photoshop:Headline',
      'XMP-photoshop:CaptionWriter',
      'XMP-photoshop:Credit',
      'XMP-photoshop:Source',
      'XMP-photoshop:Instructions',
      'XMP-photoshop:City',
      'XMP-photoshop:State',
      'XMP-photoshop:Country',
      'XMP-photoshop:Copyright',
      'XMP-iptcCore:CreatorContactInfo',
      'XMP-iptcCore:IntellectualGenre',
      'XMP-iptcCore:Location',
      'XMP-iptcExt:LocationShown',
      'XMP-iptcExt:PersonInImage',
      'XMP-iptcExt:OrganisationInImage',
    ],
  },
];
